/**
 *	Watch the DOM for changes
 *	Fires 'dom-updated' on dom changes
 */

const _ = require('underscore');
const optimizedResize = require('utilities/optimizedResize');

/**
 * DOMWatcher
 *
 *
 */
class DOMWatcher {
	constructor(selector, callback, options = {}) {
		// Misc. Options
		this.name = options.name || 'dom-watcher';
		this.domBatchTime = options.domBatchTime || 500;
		this.observerConfig = options.observerConfig || {
			childList: true,
			subtree: true
		};
		this.targetEl = options.targetEl || document.body;

		this.selector = selector;

		this.processNodes = _.debounce(() => {
			const selectors = Array.isArray(selector) ? selector : [selector];
			const results = selectors
				.filter(sel => !!sel)
				.map(sel => document.querySelector(sel))
				.filter(node => !!node);

			callback(results);
		}, this.domBatchTime);
	}

	start() {
		let targetEl = this.targetEl;
		let observerConfig = this.observerConfig;

		if (this.observer) {
			this.stop();
		}

		let observer = new MutationObserver(this.processNodes);
		observer.observe(targetEl, observerConfig);
		optimizedResize.add(this.processNodes);
		window.addEventListener('scroll', this.processNodes);
		this.observer = observer;
		this.processNodes();
	}

	stop() {
		let observer = this.observer;
		if (observer && observer.disconnect) {
			observer.disconnect();
			optimizedResize.remove(this.processNodes);
			window.removeEventListener('scroll', this.processNodes);
			this.observer = null;
			this.processNodes = () => {};
		}
	}
}

module.exports = DOMWatcher;
